module.exports = __webpack_public_path__ + "img/markerFerryOrange.21dc989d.svg";